import { useMemo } from 'react';
import { useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { useCart } from 'hooks/context/cart';
import { useGiftCardCart } from 'hooks/context/giftCardCart';
import { useMerchant } from 'hooks/context/merchant';
import { useMerchantState } from 'hooks/context/MerchantState';

export function useCanPlaceTableOrder() {
  const { isOrderProcessing, isReCaptchaReady, hasUnrecoverableError } =
    useSubmitOrder();
  const { isLoading: isMerchantLoading } = useMerchant();
  const { isAcceptingOrders, showRunningOrderState } = useMerchantState();
  const { itemCount: cartItemCount } = useCart();
  const { itemCount: giftCardCount } = useGiftCardCart();
  const itemCount = cartItemCount + giftCardCount;

  return useMemo(() => {
    return (
      showRunningOrderState &&
      itemCount > 0 &&
      isAcceptingOrders &&
      !isMerchantLoading &&
      !isOrderProcessing &&
      isReCaptchaReady &&
      !hasUnrecoverableError
    );
  }, [
    hasUnrecoverableError,
    isAcceptingOrders,
    isMerchantLoading,
    isOrderProcessing,
    isReCaptchaReady,
    itemCount,
    showRunningOrderState
  ]);
}
